import { Manager } from "redux-models/reduxStateTypes";

export const yesNoRadioOptions = [
  { name: "Yes", value: true },
  { name: "No", value: false },
];

export const loadMoreOption = [
  { name: "Loading...", id: "loadMore", disabled: true },
];

export const UNKNOWN_BDM: Manager & { name: string } = {
  id: "unknown",
  name: "Unknown",
  firstName: "Unknown",
  lastName: "",
  role: "manager",
  status: "",
  email: "centralisedlending@scottishpacific.com",
};
